import { useAppDispatch } from 'store/hooks';
import { closeModal, openModal } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { useRestreamer } from 'features/restreamer/useRestreamer';

const RestreamingConsentModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const { isFeatureAvailable } = useRestreamer();

  useEffect(() => {
    if (!isFeatureAvailable) {
      dispatch(closeModal('restreamingConsent'));
    }
  }, [isFeatureAvailable, dispatch]);

  const handleOk = () => {
    dispatch(openModal('restreamingConfig'));
  };

  const handleCancel = () => {
    dispatch(closeModal('restreamingConsent'));
  };

  return (
    <ConfirmationDialog
      open
      maxWidth="sm"
      title={t('restreaming.consent.title')}
      description={t('restreaming.consent.description')}
      cancelText={t('restreaming.consent.btn_cancel_label')}
      okText={t('restreaming.consent.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      preventClose
      hideCloseButton
    />
  );
};

export default RestreamingConsentModal;
